import { createSelector } from 'reselect';
var recoverableUIStateSelector = function recoverableUIStateSelector(state) {
  return state.customercare.recoverableUiState.discount;
};
export var DiscountFormSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.discountForm;
});
export var IsFetchingDiscountContextSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.isFetchingDiscountContext;
});
export var QualifiedDiscretionaryDiscountsSelector = createSelector([recoverableUIStateSelector], function (uiState) {
  return uiState.qualifiedDiscretionaryDiscounts || [];
});